<template>
  <div class="flex flex-1 feedback-wrapper pb-8">
    <!-- Crash reported -->
    <div
      v-if="subPage === 'crash-reported'"
      class="max-w-sm flex flex-col justify-center items-center text-center"
    >
      <img
        class="sm:w-full"
        src="../../../assets/common/report_done.svg"
        :alt="$t('homePage.report_crash_title')"
      />
      <div class="title">{{ $t('homePage.report_crash_title') }}</div>
      <div class="content" v-html="$t('homePage.report_crash_content')"></div>
    </div>
    <!-- Input feedback -->
    <div
      v-else-if="subPage === 'input-feedback'"
      class="max-w-sm flex flex-col justify-center items-center"
    >
      <textarea
        name="feedback-input"
        id="feedback-input"
        rows="10"
        ref="textarea"
        autofocus
        :placeholder="$t('homePage.send_feedback_placeholder')"
      />
      <c-button @click="feedback">
        <span>{{ $t('homePage.send_btn') }}</span>
      </c-button>
    </div>
    <!-- Feedback reported -->
    <div
      v-else-if="subPage === 'feedback-reported'"
      class="max-w-sm flex flex-col justify-center items-center text-center"
    >
      <img
        class="sm:w-full"
        src="../../../assets/common/feedback_done.svg"
        :alt="$t('homePage.send_feedback_title')"
      />
      <div class="title">{{ $t('homePage.send_feedback_title') }}</div>
      <div class="content" v-html="$t('homePage.send_feedback_content')"></div>
    </div>
    <!-- Rate -->
    <div
      v-else-if="subPage === 'rate-app'"
      class="max-w-sm flex flex-col justify-center items-center text-center"
    >
      <img
        class="sm:w-full"
        src="../../../assets/common/rate_app.svg"
        :alt="$t('homePage.rate_app_title')"
      />
      <div class="title">{{ $t('homePage.rate_app_title') }}</div>
      <div class="content" v-html="$t('homePage.rate_app_content')"></div>
    </div>
    <!-- Send feedback -->
    <div v-else class="max-w-sm flex flex-col flex-1 justify-center items-center text-center">
      <c-button class="my-5" @click="$emit('update:subPage', 'input-feedback')">
        <span>{{ $t('homePage.send_feedback') }}</span>
      </c-button>
      <c-button secondary class="my-5" @click="$emit('update:subPage', 'rate-app')">
        <span>{{ $t('homePage.rate_app') }}</span>
      </c-button>
      <c-button secondary class="my-5" @click="report">
        <span>{{ $t('homePage.report_crash') }}</span>
      </c-button>
    </div>
  </div>
</template>

<script>
import CButton from '@/components/common/CButton.vue';

export default {
  name: 'Feedback',
  components: {
    CButton,
  },
  props: {
    subPage: String,
  },
  methods: {
    feedback() {
      const $content = this.$refs.textarea;
      if (!$content || !$content.value) return;

      this.$emit('report', `[FEEDBACK] ${$content.value}`);
      this.$emit('update:subPage', 'feedback-reported');
    },
    report() {
      this.$emit('report', '[USER_REPORT]');
      this.$emit('update:subPage', 'crash-reported');
    },
  },
};
</script>

<style lang="scss" scoped>
#feedback-input {
  @apply p-3 mb-5 w-full;
  width: 80vw;
  @screen sm {
    width: 400px;
  }
  border-radius: 20px;
  background: rgba(70, 89, 255, 0.05);
  outline: none;
}
.feedback-wrapper {
  @apply px-3;
  align-items: flex-start;
  .title {
    @apply text-xl mb-4 font-bold;
  }
  .content {
    @apply text-sm;
    color: #262626;
  }
  img {
    @apply mx-auto mb-8;
  }
}
.title {
}
</style>
